import {
    ChangeDetectorRef,
    Directive,
    ElementRef,
    HostBinding,
    inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Renderer2,
    SimpleChanges
} from '@angular/core';
import { Status } from '@df/core/status';
import { Subscription } from 'rxjs';
import { IcmsIcons, IcmsIconsId } from '../icons/generated/icms-icons';
// import { NotificationInitiatorService } from '../notification/notification-initiator.service';

export type TButtonStyles = 'default' | 'default-small' | 'accent' | 'accent-small';

@Directive()
export abstract class ICmsAbstractButtonComponent implements OnChanges, OnDestroy, OnInit {
    @Input()
    status?: Status;

    /**
     * We can also pass busy  directly (without status)
     */
    @Input()
    busy = false;

    @Input()
    icon?: IcmsIcons | IcmsIconsId;

    @HostBinding('class._left-icon')
    @Input()
    leftIcon?: boolean = true;

    @Input()
    notification?: string;

    protected abstract variantInputName: string | undefined;

    /**
     * Notifiactions service
     */
    // @NgInject(NotificationInitiatorService)
    // private notificationInitiatorService: NotificationInitiatorService;

    private statusSubscription?: Subscription;
    private existingButtonClass?: string;

    protected renderer2 = inject(Renderer2);
    protected elementRef = inject(ElementRef);
    protected ref = inject(ChangeDetectorRef);

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['status']) {
            this.statusSubscription?.unsubscribe();
            this.statusSubscription = this.status?.subject.subscribe(() => this.onStatusChange());
        }
        if (this.variantInputName && changes[this.variantInputName]) {
            this.applyVariantClass();
        }
        if (changes['status'] || changes['busy']) {
            this.updateStatusClasses();
        }
    }

    ngOnInit() {
        this.applyVariantClass();
    }

    private applyVariantClass() {
        if (this.variantInputName) {
            const newClass = `_${this[this.variantInputName] || 'default'}`;
            if (this.existingButtonClass && this.existingButtonClass !== newClass) {
                this.renderer2.removeClass(this.elementRef.nativeElement, this.existingButtonClass);
            }
            if (newClass) {
                this.existingButtonClass = newClass;
                this.renderer2.addClass(this.elementRef.nativeElement, newClass);
            }
        }
    }

    ngOnDestroy() {
        this.statusSubscription?.unsubscribe();
    }

    get isBusy(): boolean {
        return !!(this.busy || this.status?.busy);
    }

    private onStatusChange() {
        this.updateStatusClasses();
        if (this.notification && this.status?.error) {
            // this.notificationInitiatorService.push({
            //     title: this.notification,
            //     message: this.status.error
            // });
        }
        this.ref.detectChanges();
    }

    private updateStatusClasses() {
        this.isBusy
            ? this.renderer2.addClass(this.elementRef.nativeElement, '_busy')
            : this.renderer2.removeClass(this.elementRef.nativeElement, '_busy');
    }
}
